import { SpeciesList } from './SpeciesList.js'

window.customElements.define('species-list', SpeciesList)
